<section class="container">
<h3>
  {{ data.details.title.split(" ")[0] }}
  <span> {{ data.details.title.split(" ")[1] }}</span>
</h3>
<p-carousel
  dir="ltr"
  [value]="groupedServices"
  [numVisible]="1"
  [numScroll]="1"
  [showIndicators]="true"
>
  <ng-template let-items pTemplate="item">
    <div class="row">
      <div
        class="col-6 col-sm-4 col-md-3"
        *ngFor="let item of items; let i = index"
      >
        <div
          class="text-center p-3"
          [ngClass]="{ pointer: item.link }"
          (click)="openLink(item.link)"
        >
          <img [src]="item.image" [alt]="item.name" class="w-100" />
          <!-- <h4 class="card-title">{{ item.name }}</h4> -->
        </div>
      </div>
    </div>
  </ng-template>
</p-carousel>
</section>